import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import WhatsAppChatWidget from "../Pages/WhatsAppChatWidget";

const BlogDetail = () => {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const API_URL = `https://ardorbiomed.com/api/api/blogs/${blogId}/`;

  useEffect(() => {
    axios
      .get(API_URL)
      .then((response) => {
        setBlog(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blog details:", error);
      });
  }, [API_URL, blogId]);

  if (!blog) {
    return <div className="text-center my-5">Loading...</div>;
  }

  return (
    <div>
      <div className="banner-section  ">
        <img
          src="../assets/img/bannerbreadcrumbs.jpg"
          alt="Banner"
          className="img-fluid banner-img"
        />
        <div className="breadcrumb-container ">
          <h2> Blog Detail</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                Blog Detail
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <section className="container my-5">
        <div className="row">
          <div className="col-lg-8">
            <h2 className="mb-3 text-center">{blog.title}</h2>
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(blog.description),
              }}
            ></div>
          </div>

          <div className="col-lg-4">
            <div className="sidebar p-4 bg-light rounded">
              <h3 className="mb-4">Recent Blogs</h3>
              {blog.related_blogs.map((recentblog) => (
                <div
                  key={recentblog.id}
                  className="d-flex mb-3 border-bottom pb-2"
                >
                  <Link
                    to={`/Blogdetail/${recentblog.id}`}
                    className="me-3"
                    style={{ width: "80px", height: "80px", display: "block" }}
                  >
                    <img
                      src={recentblog.image || "/assets/images/default.jpg"}
                      alt={recentblog.title}
                      className="img-fluid rounded"
                    />
                  </Link>
                  <div>
                    <h6 className="m-0">
                      <Link
                        to={`/Blogdetail/${recentblog.id}`}
                        className="text-dark"
                      >
                        {recentblog.title}
                      </Link>
                    </h6>
                    <p> {recentblog.hint}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="Ardor Biomed"
      />
    </div>
  );
};

export default BlogDetail;
